










































































































/**
 * 홈 - 키즈 - 책소개 - 분야별 도서(상세)
 * 메뉴명: 분야별 도서(상세)
 * 메뉴이름: KIDS_INTRODUCTION_FIELD_DETAIL
 */
import { useRouter } from '@u3u/vue-hooks';
import { computed, defineComponent, ref } from '@vue/composition-api';

import { KidsBookAuthorDTO, KidsBookDetailDTO } from '@/apis/repositories/types/kids';
import { fetchKidsBookDetail } from '@/apis/services/kidsService';
import { Breadcrumb, WPageWrapper } from '@/components/base';
import BookAuthor from '@/components/views/book/BookAuthor.vue';
import BookCover from '@/components/views/book/BookCover.vue';
import BookInfoAuthorProfile from '@/components/views/book/BookInfoAuthorProfile.vue';
import BookInfoSummary from '@/components/views/book/BookInfoSummary.vue';
import BookInfoTitle from '@/components/views/book/BookInfoTitle.vue';
import BookPublishingItem from '@/components/views/book/BookPublishingItem.vue';
import BookStoreTagList from '@/components/views/book/BookStoreTagList.vue';
import BookRelatedData from '@/components/views/kids/BookRelatedData.vue';
import { ROUTE_NAMES } from '@/constants';
import logger from '@/modules/logger';
import { sortKidsAuthorList } from '@/utils/author';

export default defineComponent({
  name: 'KidsIntroductionDetailPage',
  components: {
    Breadcrumb,
    BookPublishingItem,
    BookCover,
    BookStoreTagList,
    BookInfoTitle,
    BookInfoSummary,
    BookInfoAuthorProfile,
    BookRelatedData,
    BookAuthor,
    WPageWrapper,
  },
  setup() {
    const { route } = useRouter();
    const book = ref<KidsBookDetailDTO>();
    const sortedAuthors = ref<KidsBookAuthorDTO[]>([]);
    const attachmentImages = ref<any[]>([]);

    const bookSeq = computed(() => {
      return Number(route.value.params.id);
    });

    const getKidsBookDetail = async () => {
      try {
        book.value = await fetchKidsBookDetail(bookSeq.value, true);
        sortedAuthors.value = sortKidsAuthorList(book.value.authors);
        attachmentImages.value = book.value.attachments.filter(
          (attached: { [key: string]: any }) => attached.attachmentType === 'IMAGE',
        );

        if (book.value && book.value.meetLink) {
          const seqArr = book.value.meetLink.split(',') || [];
          if (seqArr && seqArr.length > 0) {
            const meetLinks: any[] = [];
            seqArr.forEach((seq) => {
              meetLinks.push(book.value?.meets.content.find((meet: any) => meet.seq == seq));
            });

            book.value.meets = meetLinks;
          }
        }
      } catch (error) {
        logger.log('alpha', '키즈 책소개 분야별 도서 상세 요청 실패.', error);
      }
    };

    const fetchData = () => {
      return getKidsBookDetail();
    };

    return { book, bookSeq, fetchData, sortedAuthors, attachmentImages, ROUTE_NAMES };
  },
});
